// The one extra route: /evidence (vercel.json rewrites it to index.html; Vite's dev server falls back itself).

export const isEvidencePath = (pathname: string): boolean => /^\/evidence\/?$/.test(pathname);
